// ============================================================
// Time Formats - 시간 포맷 상수 (re-export from @/common/utils/core)
// ============================================================
export {
  GLOBAL_TIME_LIVE_FORMAT,
  GLOBAL_TIME_RANGE_FORMAT,
  GLOBAL_TIME_MINUTE_FORMAT,
  UTC_TIME_FORMAT,
  UTC_TIME_FORMAT_MILLISECOND,
  MIN_DATE_TIME,
  UTC_DATE_FORMAT,
} from '@/common/utils/core/time/constants';

// ============================================================
// Period Items - 기간 항목 상수
// ============================================================

/** 커스텀 기간 접두사 */
export const CUSTOM_PERIOD_PREFIX = 'custom';

/** 기본 기간 항목 */
export const DEFAULT_PERIOD_ITEMS = [
  { name: 'Past 5 Minutes', value: 'p5m', shortName: '5m' },
  { name: 'Past 10 Minutes', value: 'p10m', shortName: '10m' },
  { name: 'Past 30 Minutes', value: 'p30m', shortName: '30m' },
  { name: 'Past 1 Hours', value: 'p1h', shortName: '1h' },
  { name: 'Past 3 Hours', value: 'p3h', shortName: '3h' },
  { name: 'Past 6 Hours', value: 'p6h', shortName: '6h' },
  { name: 'Past 12 Hours', value: 'p12h', shortName: '12h' },
  { name: 'Past 1 Day', value: 'p1d', shortName: '1d' },
] as const;

/** 7일 포함 기간 항목 */
export const DEFAULT_PERIOD_ITEMS_WITH_7_DAY = [
  ...DEFAULT_PERIOD_ITEMS,
  { name: 'Past 7 Day', value: 'p7d', shortName: '7d' },
] as const;

/** 전체 기간 항목 (31일 포함) */
export const DEFAULT_PERIOD_ITEMS_ALL = [
  ...DEFAULT_PERIOD_ITEMS,
  { name: 'Past 7 Day', value: 'p7d', shortName: '7d' },
  { name: 'Past 31 Day', value: 'p31d', shortName: '31d' },
] as const;

// ============================================================
// Time Units - 시간 단위 상수
// ============================================================

/** 시간 단위 정보 (i18n용) */
export const TIME_UNITS = [
  { labelSingle: 'WORD.DAY', labelPlural: 'WORD.DAYS', duration: 86400 },
  { labelSingle: 'WORD.HOUR', labelPlural: 'WORD.HOURS', duration: 3600 },
  { labelSingle: 'WORD.MINUTE', labelPlural: 'WORD.MINUTES', duration: 60 },
  { labelSingle: 'WORD.SECOND', labelPlural: 'WORD.SECONDS', duration: 1 },
] as const;

// ============================================================
// Default Values - 기본값 상수
// ============================================================

/** 기본 기간 */
export const DEFAULT_TIME_PERIOD = 'p10m';

/** 기본 갱신 주기 */
export const DEFAULT_INTERVAL = 'I5s';

/** Worker 기본 갱신 주기 (ms) */
export const DEFAULT_WORKER_INTERVAL_MS = 5_000;
